/**
 * VALUES THE PAGE HELD BUT NO LONGER SHOWS (security code review R-8): a value
 * read from the URL and then scrubbed from the address bar (Book's checkout
 * return boot takes `ref` and removes it) is still the page's own data, so the
 * scrubber (./scrub.ts) removes it from reports like a path token. Kept for
 * the page's life.
 *
 * Its own module, with no imports: the return boot holds a value without
 * importing the scrubber, which belongs to the reporter's lazy chunk. Importing
 * it there moved the reporter's code into the Book entry (+1.8 KiB, measured).
 */
const held = new Set<string>();

export function holdPageScrubToken(value: string): void {
  if (value.length >= 3) held.add(value);
}

/** The held values, for the scrubber. */
export function heldPageScrubTokens(): Iterable<string> {
  return held;
}

/** Test-only. */
export function __resetHeldScrubTokensForTests(): void {
  held.clear();
}
